import React from 'react';
import moment from 'moment';

export default class MaintenanceRow extends React.Component {
  render() {
    const props       = this.props;
    const RowData     = this.props.RowData;
    const IsPerAsset  = props.hasOwnProperty('assetData')
    let executeButton, editButton, manageButton = null;

    if(RowData.Status === 'incomplete') {
      if(RowData.Service.hasOwnProperty('IsQuickTest')) {
        if(RowData.Service.IsQuickTest) {
          executeButton = <button onClick={()=>props.onStartQuickTest(RowData.Alias)} className="btn btn-sm btn-primary">Quick Test</button>
        }else {
          executeButton = <button onClick={()=>props.onStartWork(RowData.Alias)} className="btn btn-sm btn-primary">Start Work</button>
        }
      }

      editButton = <button onClick={()=>props.self.openModalEdit(RowData)} type="button" className="btn btn-4r btn-sm btn-primary"><i className="icon-pencil"></i></button>

    } else if (RowData.Status === 'in-progress') {
      executeButton = <button onClick={()=>props.onFinishWork(RowData.Alias)} className="btn btn-sm btn-success">Finish Work</button>
      editButton = <button onClick={()=>props.self.openModalEdit(RowData)} type="button" className="btn btn-4r btn-sm btn-primary"><i className="icon-pencil"></i></button>

    } else {
      executeButton = <button className="btn btn-sm btn-default" disabled>Completed</button>
      editButton = <button type="button" className="btn btn-4r btn-sm btn-default" disabled><i className="icon-pencil"></i></button>
    }

    if(RowData.IsReminder === 'Yes' && RowData.Status !== 'completed' && RowData.Status !== 'in-progress') {
      if (IsPerAsset){
        manageButton = <a className="manage-button apple-blue hover-apple-blue" onClick={()=>props.history.push('../maintenance/remainder-list/' + RowData.Alias + '/' + RowData.Asset.Name)} role="button">Manage Reminder</a>;

      }else{
        manageButton = <a className="manage-button apple-blue hover-apple-blue" onClick={()=>props.history.push('maintenance/remainder-list/' + RowData.Alias + '/' + RowData.Asset.Name)} role="button">Manage Reminder</a>;
      }
      
    } else {
      manageButton = <a className="manage-button disable" role="button">Manage Reminder</a>;
    }

    const assetNameField = () => {
      if(IsPerAsset){
        return null;
      }else{
        return (
          <td>
            <div>
              <strong className="spaceR">{RowData.Asset.Name}</strong>(<span>{RowData.Asset.Alias}</span>)
            </div>
          </td>
        )
      }
    }

    return (
      <tr>
        {assetNameField()}
        <td className="text-center">
          <span>{RowData.Service.Name}</span>
          <div className="text-muted">
            <small><span>Duration:</span>&nbsp;<span>{RowData.Service.Duration}</span>&nbsp;<span>Hours</span></small>
          </div>
        </td>
        <td className="text-center">
          <span>{moment(RowData.ScheduledStart).format('ll')}</span>
        </td>
        <td className="text-center">
          <span>{moment(RowData.ScheduledEnd).format('ll')}</span>
        </td>
        <td className="text-center">
          <span>{RowData.IsReminder}</span>
          <div className="small text-muted">
            {manageButton}
          </div>
        </td>
        <td className="text-center">
          {editButton}
        </td>
        <td className="text-center">
          {executeButton}
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/MaintenanceList/MaintenanceRow.js